import {formatCurrency, formatPercentWithTwoDecimals} from "../../../utils/format";
import React from "react";
import classNames from "classnames";
import {TaxType} from "../../../WealthTransfer/components/EstateTaxRunningTotal";

export type EstateTaxBreakdownReportRowProps = {
    rowId: string,
    parentRowId?: string,
    title?: string
    amount?: number;
    amountWithStrategies: number;
    description?: string;
    additionClassNames?: string[];
    isStrategyRow: boolean;
    isTaxRateRow: boolean;
    type: TaxType;
}

// NOTE : PLEASE CHECK THE IMPACT OF CHANGES TO THIS COMPONENT ON EstateTaxRunningTotal

export const EstateTaxBreakdownReportRow = ({
                                                rowId,
                                                parentRowId,
                                                title = "",
                                                amount = undefined,
                                                amountWithStrategies,
                                                description = "",
                                                additionClassNames = [],
                                                isStrategyRow = false,
                                                isTaxRateRow = false,
                                                type
                                            }: EstateTaxBreakdownReportRowProps) => {
    const formatAmount = (amount: number): string => {
        if (isTaxRateRow) {
            return formatPercentWithTwoDecimals(amount / 100);
        }
        return (amount !== 0) ? formatCurrency(amount) : "$0";
    }

    const formattedAmountWithoutStrategies: string = amount !== undefined ? formatAmount(amount) : "";
    const formattedAmountWithStrategies: string = formatAmount(amountWithStrategies);

    return (
        <div data-testid={"line-item-row-wpo"} className={classNames("line-item-row-wpo", ...additionClassNames)}
             key={`${type}-${rowId}-${parentRowId}`}>
            <div className={"span-1"}>{title}</div>
            <div className={"span-2"}>{formattedAmountWithoutStrategies}</div>
            <div className={classNames("span-3",
                {"amt-to-beneficiaries": isStrategyRow},
                {"text-content": isStrategyRow})}>
                {formattedAmountWithStrategies}
            </div>
            <div className="span-4 strategy-description">
                <div className={classNames("text-content",
                    {"sor-description": isTaxRateRow})}>{description}</div>
            </div>
        </div>);
}